<div class="col-xl-12 cropPopup">
	<div mat-dialog-title class="dialog-title">
		<div fxLayout="row" fxLayout.lt-md="column" fxFlex fxLayoutGap="20px">
			<div fxFlex class="filterName">
				{{data.title}}
			</div>
		</div>
	</div>
	<div mat-dialog-content class="dialog-content">
		<div class="ImageTabContainer" *ngIf="showImageTabContainer">
			<img [src]="pictureLink">
		</div>
		<div *ngIf="showCropper">
			<image-cropper style="height:300px"
				[imageURL]="initialImageUrl"
				[imageChangedEvent]="imageChangedEvent"
				[maintainAspectRatio]="!(selectedRatio === 0)"
				[aspectRatio]="selectedRatio"
				format="png"
				[autoCrop]="true"
				(imageCropped)="imageCropped($event)"
				(imageLoaded)="imageLoaded()"
				(cropperReady)="cropperReady()"
				(loadImageFailed)="loadImageFailed()"></image-cropper>
		</div>

	</div>
	<div mat-dialog-actions class="dialog-actions">
		<div style="width: 100%;margin-top:10px;">
			<button mat-raised-button color="danger" (click)="closeModal(undefined)">{{'Close' | translate}}</button>
			<input #imageInput [hidden]="true" type="file" name="upfileLogo" accept="image/*" multiple="false"
				id="image_selector" (change)="fileChangeEvent($event)">
			<button mat-raised-button (click)="imageInput.click()" [disabled]="loading">{{'Select' |
				translate}}</button>
			<button mat-raised-button (click)="cropIt()" *ngIf="showCropActions"
				[disabled]="loading">{{'Confirm Crop and Upload' | translate}}</button>
			<button mat-raised-button (click)="clearIt($event)" *ngIf="showCropActions"
				[disabled]="loading">{{'Clear' | translate}}</button>
		</div>
	</div>
	<br />
</div>